export const SERVER_URL = "https://spyder-api.vercel.app/api";
